import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NotificationStoreEffects } from './effects';
import { NotificationReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature('Notification', NotificationReducer), EffectsModule.forFeature([NotificationStoreEffects])],
  providers: [NotificationStoreEffects],
})
export class NotificationStoreModule {
  Notification: any;
}
